import {
  ChangeDetectionStrategy,
  Component,
  input,
  TemplateRef,
  signal,
  inject,
  effect,
} from '@angular/core';
import { EventAttendee } from '../../../../../gen';
import { StatusAttendeePipe } from 'src/app/common/pipes/status-attendee.pipe';
import { NgClass } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

// ✅ adapte le chemin si nécessaire
import { EventsService } from '../../../../../gen';

@Component({
  selector: 'mlk-event-attendee',
  templateUrl: './event-attendee.component.html',
  styleUrls: ['./event-attendee.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StatusAttendeePipe, NgClass],
  standalone: true,
})
export class EventAttendeeComponent {
  readonly eventId = input.required<string>();

  public userId!: string;
  public nbNewAttendee: boolean = false;

  private updateModalFromRef: NgbModalRef | null = null;

  private readonly modalService = inject(NgbModal);
  private readonly eventsService = inject(EventsService);

  readonly eventAttendee = input.required<EventAttendee>();

  // ✅ mêmes valeurs/approche que SingleEventAmbViewComponent
  private readonly anonymousGuests = signal<{
    adults: number;
    children: number;
  }>({
    adults: 0,
    children: 0,
  });

  constructor() {
    effect(() => {
      // dès que l'eventId est disponible ou change
      this.refreshAnonymousGuests();
    });
  }

  public openUpdateModalForm(content: TemplateRef<unknown>) {
    this.updateModalFromRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
    });
  }

  public onSubmitForm() {}

  /**
   * ✅ À appeler avec l’id attendu par l’API (comme dans SingleEventAmbViewComponent)
   * Typiquement tu l’as déjà quand tu cliques sur "Ajouter des participants"
   */
  public refreshAnonymousGuests() {
    const eventId = this.eventId();

    this.eventsService
      .eventsAnonymousGuestsRetrieve({ id: eventId })
      .subscribe({
        next: guests => {
          this.anonymousGuests.set({
            adults: guests.adults ?? 0,
            children: guests.children ?? 0,
          });
        },
        error: () => {
          this.anonymousGuests.set({ adults: 0, children: 0 });
        },
      });
  }

  public openAddAttendees(id: string) {
    // ... ton code existant (ouverture modal, etc.)

    // ✅ Optionnel : refresh immédiat (ou après fermeture modal si tu préfères)
    this.refreshAnonymousGuests();
  }

  public cancelMember() {
    //alert('got');
  }

  // ✅ GETTERS basés sur l’API
  public get guestAdultsCount(): number {
    return this.anonymousGuests().adults;
  }

  public get guestChildrenCount(): number {
    return this.anonymousGuests().children;
  }

  public get guestTotalCount(): number {
    const { adults, children } = this.anonymousGuests();
    console.log('adults', adults, 'children', children);
    return adults + children;
  }
}
